import { render, staticRenderFns } from "./Servidor.vue?vue&type=template&id=62a8447b"
import script from "./Servidor.vue?vue&type=script&lang=js"
export * from "./Servidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports